import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import { site } from "@/mocks/site";

export default function CtaSection() {
  return (
    <section className="bg-background-50 pb-20 pt-4 md:pb-28">
      <div className="shell">
        <Reveal>
          <div className="relative overflow-hidden rounded-xl">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimal%20modern%20dental%20clinic%20reception%20interior%20with%20wood%20and%20ivory%20tones%2C%20soft%20daylight%2C%20green%20plants%2C%20clean%20calm%20waiting%20area%2C%20editorial%20architectural%20photography%2C%20no%20people%2C%20no%20text&width=1200&height=800&seq=dmar-clinic-interior&orientation=landscape"
              alt="d.mar Dental Görüntüleme Merkezi bekleme alanı"
              title="d.mar Dental Görüntüleme Merkezi — Osmanbey / Şişli"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-primary-950/90 via-primary-950/80 to-primary-900/70" aria-hidden="true" />

            <div className="relative flex flex-col items-center px-6 py-16 text-center md:px-16 md:py-24">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-accent-300">
                <i className="ri-calendar-check-line text-sm" aria-hidden="true" />
                Hızlı randevu
              </span>
              <h2 className="mt-6 max-w-2xl font-heading text-3xl font-medium leading-tight tracking-tight text-background-50 md:text-4xl lg:text-[2.75rem]">
                Diş hekiminiz film istediyse, WhatsApp'tan yazın.
              </h2>
              <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200/90 md:text-base">
                Aynı gün randevu, 60 saniyede işlem. Görüntü ve rapor aynı gün diş hekiminize dijital
                olarak iletilir.
              </p>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Button href={site.whatsapp} external variant="accent" size="lg" icon="ri-whatsapp-line">
                  WhatsApp'tan Yaz
                </Button>
                <Button href={site.phoneMainHref} variant="outlineLight" size="lg" icon="ri-phone-line">
                  {site.phoneMain}
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}